export default __webpack_public_path__ + "static/media/photo--lg--kickoff2.45fdc67e.jpg";